import axios from "axios";
import LS from 'local-storage';
import {APIError, validateError} from "../../common/utils/errors";
import eventBus from "../../common/utils/eventBus";

const baseURL = global.API_URI || "";
const http = axios.create({
    baseURL,
});

// const token = '2136d594fa88c7744ea6775272055004';

http.interceptors.request.use(
    config => {
        const token = LS.get('token');
        config = Object.assign(config, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        return config
    }
);
http.interceptors.response.use(function (resp) {
    const json = resp.data;

    if (!json.status && json.error && json.error.msg) {
        const msg = json.error.msg.length ? json.error.msg : '网络错误';
        const code = json.error.code ? json.error.code : 0;

        if (json.error.validate) {
            return Promise.reject(new validateError(msg, code, json.error.validate))
        }

        const error = new APIError(msg, code);
        console.log(error);

        eventBus.$emit('error', error);

        return Promise.reject(error)
    }

    return Promise.resolve(json.data);
});

export {http};

export default {
    getDashboard() {
        return http.get("/member/dashboard")
    },
    saveTracking(ga_trakcing_id, statCounter_project_id, statCounter_security_id) {
        return http.post("/member/new-options", {
            ga_trakcing_id,
            statCounter_project_id,
            statCounter_security_id,
        })
    },
    saveColor(primary_color='', text_color='', accent_color='') {
        return http.post("/member/new-options", {
            primary_color,
            text_color,
            accent_color
        })
    },
    getUploadURL() {
        return `${baseURL}/upload/save`
    },

    editBlock(text, type = 1, url = null, state = 0, image = null, icons = null, block_id = null, position = null) {
        const data = {
            text,
            'type': type === 2 ? 2 : 1,
            url,
            state,
            image,
            icons,
            block_id,
            position,
        }

        const formatData = Object.entries(data).filter(([key, value]) => {
            return value !== null && value !== undefined;
        });

        return http.post("/member/new-block", Object.fromEntries(formatData))
    },
    removeBlock(block_id) {
        return http.get(`/member/remove-block/${block_id}`)
    },
    getIcons() {
        return new Promise((resolve, reject) => {
            if (window.iconsCache) {
                return resolve(window.iconsCache);
            }

            return http.get("/icons")
                .then((data) => {
                    window.iconsCache = data;
                    return resolve(data);
                }, reject)
        });
    },
    blocksSort(blocks) {
        return http.post("/member/blocks-sort", {blocks})
    },
    logout(){
      return http.post("/logout")
    },
    resetPwd(hash, pwd){
      return http.post("/member/pwd/reset", {hash, pwd})
    },
    resetEmail(){
        return http.post("/member/reset-pwd/email");
    },

    getTrackingFData(){
        return http.post("/member/tracking");
    },
}